const periodValues = [
    {
        id: 1,
        title: '1 day',
        value: 1
    },
    {
        id: 2,
        title: '7 days',
        value: 7
    },
    {
        id: 3,
        title: '30 days',
        value: 30
    },
]

export default periodValues